// extracted by mini-css-extract-plugin
export default {"border":"ChartStyle_border__7acpI"};